<template>
  <div class="cart-footer">
    <div>
      商品数: <span>{{ totalCount }}</span> | 折扣: <span>¥{{ totalDiscount.toFixed(2) }}</span>
    </div>
    <div class="total-display">¥ {{ mainTotal.toFixed(2) }}</div>
  </div>
</template>

<script>
export default {
  name: 'CartFooter',
  props: {
    totalCount: {
      type: Number,
      default: 0
    },
    totalDiscount: {
      type: Number,
      default: 0
    },
    mainTotal: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
.cart-footer {
  height: 75px;
  background: #334155;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;
  font-size: 1rem;
}

.total-display {
  font-size: 2.2rem;
  font-weight: bold;
  color: #f59e0b;
}
</style>

